import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Header';
import Banner from '../Banner';
import Footer from '../../Footer';

const content = {
  tr: {
    title: 'Fatura Bilgileri',
    description: 'Resmi fatura ve ödeme bilgilerimiz',
    companyLabel: 'Firma adı:',
    addressLabel: 'Merkez adres:',
    phoneLabel: 'Telefon:',
    taxOfficeLabel: 'Vergi Dairesi:',
    taxOffice: 'Üsküdar Vergi Dairesi',
    taxNumberLabel: 'Vergi Numarası:',
    registryLabel: 'Ticaret sicil numarası:',
  },
  en: {
    title: 'Invoice Information',
    description: 'Our official invoice and payment information',
    companyLabel: 'Company name:',
    addressLabel: 'Head office address:',
    phoneLabel: 'Phone:',
    taxOfficeLabel: 'Tax Office:',
    taxOffice: 'Üsküdar Tax Office',
    taxNumberLabel: 'Tax Number:',
    registryLabel: 'Trade registry number:',
  },
};

const Invoice: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const lang: 'en' | 'tr' = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const page = content[lang];

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    navigate(newPath + location.search, { replace: true });
  };

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={page.title}
        description={page.description}
        image={process.env.PUBLIC_URL + '/banner.png'}
      />
      <div className="max-w-xl mx-auto bg-white rounded-xl shadow-lg p-8 mt-10 mb-16">
        <h2 className="text-2xl font-bold mb-6 text-center">{page.title}</h2>
        <div className="space-y-3 text-gray-800 text-base">
          <div><span className="font-semibold">{page.companyLabel}</span> CG Yapay Zeka Teknoloji Yatırımları Anonim Şirketi</div>
          <div><span className="font-semibold">{page.addressLabel}</span> Kandilli Mah. Rasathane Cad. Kandilli Rasathanesi Afet Hazırlık Binası No: 104/12 İç Kapı No: 9 Üsküdar/İstanbul</div>
          <div><span className="font-semibold">{page.phoneLabel}</span> 444 5 860</div>
          <div><span className="font-semibold">{page.taxOfficeLabel}</span> {page.taxOffice}</div>
          <div><span className="font-semibold">{page.taxNumberLabel}</span> 2091891592</div>
          <div><span className="font-semibold">{page.registryLabel}</span> 1075977</div>
        </div>
      </div>
      <Footer language={lang} />
    </div>
  );
};

export default Invoice;
